<template>
  <div>
    <v-card>
      <v-container>

        <h2 class="mt-3 mb-1">1. Description of the Challenge</h2>
        <p>
          <a href="https://arxiv.org/abs/1802.07856" target="_blank">xView</a> is one of the largest publicly available sets of overhead imagery. It contains images from complex scenes around the world, annotated with more than one million bounding boxes representing a diverse range of 60 object classes. Compared to other overhead imagery datasets, xView images are high-resolution, multi-spectral, and labeled with a greater variety of objects.
        </p>
         
        <p>
          Given a high-resolution satellite image, the Challenge task is to predict a bounding box for each object in the image. The DIUx xView Challenge is focused on accelerating progress in four computer vision frontiers: Reduce minimum resolution for detection; Improve learning efficiency; Enable discovery of more object classes; Improve detection of fine-grained classes.
        </p>
         
        <p>
          The DIUx xView Challenge follows in the footsteps of Challenges such as <a href="http://cocodataset.org/" target="_blank">Common Objects in Context (COCO)</a> and seeks to build off <a href="http://explore.digitalglobe.com/spacenet" target="_blank">SpaceNet</a> and <a href="https://www.iarpa.gov/challenges/fmow.html" target="_blank">Functional Map of the World (FMoW)</a> to apply computer vision to the growing amount of available imagery from space so that we can understand the visual world in new ways and address a range of important applications.
        </p>

        <h2 class="mt-3 mb-1">2a. Dates</h2>
        <v-container>
          <v-layout row justify-center class="mx-2">
            <v-flex sm6 class="mx-2">
              <v-data-table
                :headers="headersTimeline"
                :items="itemsTimeline"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left"> {{ props.item.milestone }}</td>
                  <td class="text-xs-left"> {{ props.item.date }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>

        <h2 class="mt-3 mb-1">2b. Workshop Details</h2>
        <p>
          September 21, 2018<br>
          9:00 - 16:00<br>
          Social networking event to follow<br>
        </p>
        <p>
          <a href="https://www.capitalfactory.com" target="_blank">Capital Factory</a><br>
          701 Brazos St, Suite 1600 (<a href="https://goo.gl/maps/9oZYhvmkQby" target="_blank">map</a>)<br>
          Austin, TX 78701<br>
        </p>

        <h2 class="mt-3 mb-1">3. Evaluation Guidelines</h2>
        <p>
          Solvers are recommended, but not restricted, to train their algorithms on xView training dataset. The <a href="/data-download-direct">download page</a> has links to download xView images and ground-truth annotations. To be eligible for an incentive, solvers must make a valid submission by the relevant deadline. The <a href="/challenge-evaluation">evaluation page</a> has detailed information regarding how submissions will be scored. Challenge participants with the most successful and innovative methods will be invited to present at the workshop.
        </p>

        <h2 class="mt-3 mb-1">4. Motivation</h2>
        <p>
          When disasters such as Hurricane Irma in 2017 swept a trail of destruction and flooding from the Bahamas to Florida, analysts at the National Geospatial-Intelligence Agency (NGA) were tasked each day with analyzing hundreds of high-resolution satellite images. From damaged buildings to impassable roads and flooded bridges, overhead imagery informed rescue and cleanup efforts.
        </p>
        <p>
          The abundance of available data from satellites at increasingly high spatial and temporal resolutions and the growing global significance of real-world applications enabled by that imagery provide impetus for creating more sophisticated and robust models and algorithms for overhead object detection. We hope xView will become a central resource for a broad of range of vision related research and will improve the future of disaster response.
        </p>

        <h2 class="mt-3 mb-1">5. Follow-On Acquisition</h2>
        <p>
          Participants in the DIUx xView Challenge may be awarded an agreement with the Government to further prototype their solution. For eligibility for follow-on opportunities, participants will be assessed on their technical merit and ability to scale their solution. At the Government's discretion, participants may be asked to enter into negotiations with the Government for an agreement governed by 10 U.S.C. § 2371b 'Other Transaction' authority. This award will take place after the conclusion of the DIUx xView Challenge. 
        </p>

      </v-container>
    </v-card>
  </div>

</template>

<script>
  export default {
    data () {
      return {
        // path_to_unlabeled_image: 'static/example_unlabeled_med.jpg', // md: 300x300px
        // path_to_labeled_image: 'static/example_labeled_med.jpg',
        path_to_unlabeled_image: 'static/example_unlabeled.jpg', // full: 600x600px
        path_to_labeled_image: 'static/example_labeled.jpg',
        // path_to_unlabeled_image: 'static/example_unlabeled_sm.jpg', // sm: 150x150px
        // path_to_labeled_image: 'static/example_labeled.jpg_sm'
        headersTimeline: [
          {'text': 'Event', 'align': 'left', 'sortable': false, 'value': 'milestone', 'class': 'cardgray'},
          {'text': 'Date', 'align': 'left', 'sortable': false, 'value': 'date', 'class': 'cardgray'}
        ],
        itemsTimeline: [
          {'value': false, 'align': 'left', 'milestone': 'Pre-registration Opens', 'date': '2/15/18'},
          {'value': false, 'align': 'left', 'milestone': 'Dataset Launch', 'date': '3/30/18'},
          {'value': false, 'align': 'left', 'milestone': 'Challenge Launch', 'date': '5/9/18'},
          {'value': false, 'align': 'left', 'milestone': 'Progress Point 1', 'date': '6/15/18'},
          {'value': false, 'align': 'left', 'milestone': 'Progress Point 2', 'date': '7/13/18'},
          {'value': false, 'align': 'left', 'milestone': 'Final Submissions Due', 'date': '8/17/18'},
          {'value': false, 'align': 'left', 'milestone': 'Announce Winners', 'date': '8/31/18'},
          {'value': false, 'align': 'left', 'milestone': 'Technical Write-ups Due', 'date': '9/14/18'},
          {'value': false, 'align': 'left', 'milestone': 'xView Workshop', 'date': 'Sept 2018'}
        ]
      }
    },
    mounted () {
      // console.log('ChallengeDetails component mounted')
      // console.log('store baseUrl: ', this.$store.state.baseUrl)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Challenge/ChallengeDescription.vue